import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  enabled: boolean;
  onChange(enabled: boolean): void;
};

type HelpLinkProps = { href: string; children?: React.ReactNode };
const HelpLink: React.FC<HelpLinkProps> = ({ href, children }: HelpLinkProps) => (
  <a href={href} target="_blank" rel="noreferrer" className="text-blue-700 underline">
    {children}
    <FontAwesomeIcon icon={faExternalLink} className="pl-1" />
  </a>
);

export const ViewModelIndividualPermissions: React.FC<Props> = ({ enabled, onChange }: Props) => {
  const { t } = useTranslation();
  const handleOnChange = () => {
    onChange(!enabled);
  };

  return (
    <>
      <div className="px-2 pb-2">
        <Trans
          i18nKey="group.viewModelPermissions.description"
          components={{
            helpLink: <HelpLink href="https://balus-help.levii.co.jp/hc/ja/articles/48249939676825" />,
          }}
        />
        <br />
        <ul className="list-disc pl-8">
          <li>{t('group.viewModelPermissions.sharedWorkspace')}</li>
          <li>{t('group.viewModelPermissions.personalWorkspace')}</li>
        </ul>
        <br />
        {t('group.viewModelPermissions.offWarning')}
      </div>
      <label className="block cursor-pointer p-2 hover:bg-gray-200">
        <input
          type="checkbox"
          className="form-checkbox size-4 cursor-pointer border-brand"
          checked={enabled}
          onChange={handleOnChange}
        />
        <span className="px-2">{t('group.viewModelPermissions.enable')}</span>
      </label>
    </>
  );
};
